import { createSelector } from '@ngrx/store';
import { getMenuState, MenuState } from '../menu.reducer';
import { ItemDetailState } from './item-detail.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';

const getState = createSelector(getMenuState, (state: MenuState) => state.itemDetail);

const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getSelectedItemDetail = createSelector(getState, (state: ItemDetailState) => state.selectedItemDetail);
const getValidSelectedItemDetail = createSelector(
    getSelectedItemDetail,
    asyncActionStateSelectors.getHasError,
    asyncActionStateSelectors.getSuccess,
    (item, hasError, success) => (!hasError && success ? item : null)
);

const getSelectedCascadeSubmenus = createSelector(getState, (state: ItemDetailState) => state.selectedCascadeSubmenus);

const getIsCopied = createSelector(getState, (state: ItemDetailState) => state.isCopied);

export const ItemDetailSelectors = {
    ...asyncActionStateSelectors,
    getValidSelectedItemDetail,
    getSelectedCascadeSubmenus,
    getIsCopied,
};
